import React from "react";
import {Website} from "../layouts/Website";
import {PageTitle} from "../components/shared/PageTitle";
import {Box, Container, Typography} from "@mui/material";

export const Agenda = () => {
    return (
        <Website>
            <Container sx={{py: 5}}>
                <PageTitle title={'Agenda Convention'} image={'icon-agenda'}/>
                <Typography color={'#243773'} variant={'h3'}>
                    GIOVEDÌ 13 MARZO 2025
                </Typography>
                <Box sx={{
                    mt:2,
                    width:'100%',
                    height:'fit-content',
                    p:2,
                    border:'2px solid #b4b4b4',
                    borderRadius:'15px',
                    display:'flex',
                    flexDirection:'column',
                    justifyContent:'flex-start',
                    rowGap:'10px'
                }}>
                    <Typography color={'#243773'} variant={'h5'} fontFamily={'Arial'} fontWeight={'bold'}>
                        MATTINA
                    </Typography>
                    <Box>
                        <Typography color={'#d2202e'} variant={'h6'} fontFamily={'Arial B'} fontWeight={'bold'}>
                            DALLE 9.00 | 11.00
                        </Typography>
                        <Typography color={'#000'} variant={'body'} fontFamily={'Arial'} fontWeight={'bold'}>
                            Relatori / Speech <br/>
                        </Typography>
                        <Typography color={'#000'} variant={'body'} fontFamily={'Arial'} fontWeight={'normal'}>
                            Dettagli qui......
                        </Typography>
                    </Box>
                    <Box>
                        <Typography color={'#d2202e'} variant={'h6'} fontFamily={'Arial B'} fontWeight={'bold'}>
                            DALLE 11.00 | 13.00
                        </Typography>
                        <Typography color={'#000'} variant={'body'} fontFamily={'Arial'} fontWeight={'bold'}>
                            Relatori / Speech <br/>
                        </Typography>
                        <Typography color={'#000'} variant={'body'} fontFamily={'Arial'} fontWeight={'normal'}>
                            Dettagli qui......
                        </Typography>
                    </Box>



                    <Typography color={'#243773'} variant={'h5'} fontFamily={'Arial'} fontWeight={'bold'}>
                        POMERIGGIO
                    </Typography>
                    <Box>
                        <Typography color={'#d2202e'} variant={'h6'} fontFamily={'Arial B'} fontWeight={'bold'}>
                            DALLE 14.00 | 16.00
                        </Typography>
                        <Typography color={'#000'} variant={'body'} fontFamily={'Arial'} fontWeight={'bold'}>
                            Relatori / Speech <br/>
                        </Typography>
                        <Typography color={'#000'} variant={'body'} fontFamily={'Arial'} fontWeight={'normal'}>
                            Dettagli qui......
                        </Typography>
                    </Box>
                    <Box>
                        <Typography color={'#d2202e'} variant={'h6'} fontFamily={'Arial B'} fontWeight={'bold'}>
                            DALLE 16.00 | 17.00
                        </Typography>
                        <Typography color={'#000'} variant={'body'} fontFamily={'Arial'} fontWeight={'bold'}>
                            Relatori / Speech <br/>
                        </Typography>
                        <Typography color={'#000'} variant={'body'} fontFamily={'Arial'} fontWeight={'normal'}>
                            Dettagli qui......
                        </Typography>
                    </Box>
                </Box>
            </Container>
        </Website>
    )
}
